<template>
  <div>
    <el-dialog
      :append-to-body="true"
      :title="status?'查看组织':'编辑组织'"
      :visible.sync="editDialogVisible"
       :close-on-click-modal="false"
      width="30%"
      :before-close="closeEditDialog">
       <el-form label-width="80px" ref="ruleForm"  :rules="rules" :model="form" :disabled="status!==false">
        <el-form-item label="组织名" prop="organizationName">
          <el-input v-model.trim="form.organizationName" autocomplete="off" placeholder="请输入组织名"></el-input>
        </el-form-item>
        <el-form-item label="组织类型" prop="organizationType" >
          <el-radio-group v-model="form.organizationType" :disabled="true">
            <el-radio :label="0">管理平台</el-radio>
            <el-radio :label="2">厂商</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="创建时间" prop="createTime">
          <el-input
          v-model="form.createTime"
          autocomplete="off"
           :disabled="true"
           placeholder="请输入创建时间"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" autocomplete="off" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeEditDialog">关 闭</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" v-if="status===false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { editOrg, viewOrg } from '@/api/organization'
export default {
  props: {
    editDialogVisible: {
      type: Boolean,
      default: false
    },
    orgId: {
      type: String
    },
    status: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      form: {},
      rules: {
        organizationName: [
          { required: true, message: '组织名不能为空', trigger: 'blur' }
        ],
        organizationType: [
          { required: true, message: '请选择组织类型', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    this.getViewOrgData()
  },
  mounted () {

  },
  methods: {
    getViewOrgData () {
      viewOrg(this.orgId).then((res) => {
        res.data.data.organizationType = res.data.data.organizationType === 'PASS' ? 0 : 2
        this.form = Object.assign({}, res.data.data)
      })
    },
    closeEditDialog () {
      this.$emit('closeEditDialog')
    },
    submitForm () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const params = {
            organizationId: this.orgId,
            organizationName: this.form.organizationName,
            organizationType: this.form.organizationType,
            remark: this.form.remark
          }
          editOrg(params).then((res) => {
            if (res.data.code === 200 || res.data.code === 0) {
              this.$message({
                type: 'success',
                message: '更新成功'
              })
              this.$emit('closeEditDialog', 1)
            }
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang='less' scoped>

</style>
